module.exports = __webpack_public_path__ + "img/IMG_1401_L_Wood.46ddc5b5.jpg";